import { analytics } from '@silvertours/front-entities';
import { Ui } from '@silvertours/front-shared';
import { useTranslations } from 'next-intl';

type Props = {
  isLoggedIn: boolean;
};

const Footer = ({ isLoggedIn }: Props) => {
  const t = useTranslations('features.navigationLegacy.login');
  return (
    <>
      {t('noAccountText')}{' '}
      <Ui.TextLink
        href={t('signup.href')}
        text={t('signup.text')}
        onClick={() => analytics.gtm.trackNewUser({ isLoggedIn })}
      />
    </>
  );
};

export { Footer };
